import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiOneThirdImageWithCopy' })(
  ({ brandType, brandColors, breakpoints, type, typography }) => ({
    container: {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      backgroundColor: brandColors.offWhite,
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        flexDirection: 'row',
      },
    },
    textSection: {
      padding: typography.pxToRem(24),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(22),
        paddingRight: typography.pxToRem(10),
        paddingTop: typography.pxToRem(10),
        paddingBottom: typography.pxToRem(16),
        ...brandType['body-s'],
        lineHeight: typography.pxToRem(16),
      },
    },
    imageSection: {
      width: '100%',
      padding: 0,
      height: '100%',
      objectFit: 'cover',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        padding: 0,
      },
    },
    backgroundImageSection: {
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      marginBottom: typography.pxToRem(8),
    },
    heading: {
      ...type['44_medium'],
      textWrap: 'pretty',
      marginBottom: typography.pxToRem(10),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        padding: 0,
        ...brandType['heading-xxs'],
      },
    },
    imageTopPositionFromRight: {
      flexDirection: 'column-reverse',
    },
    imageTopPositionFromLeft: {
      flexDirection: 'column',
    },
  })
);

export default useStyles;
